var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMesasSilla(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.39 38.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #a1bac4;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PLANO"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 30.35,
    cy: 12.38,
    rx: 14.58,
    ry: 6.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 29.32,
    y: 14.8,
    width: 2.06,
    height: 19.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m24.26,36.95c-.44,0-.85-.27-.99-.69-.16-.51.15-1.04.7-1.19l6.09-1.67c.19-.05.39-.05.58,0l6.09,1.67c.55.15.86.68.7,1.19-.16.51-.73.8-1.28.65l-5.8-1.59-5.8,1.59c-.1.03-.2.04-.29.04Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m41.39,34.37c-.57,0-1.03-.43-1.03-.96v-11.3c0-.53.46-.96,1.03-.96s1.03.43,1.03.96v11.3c0,.53-.46.96-1.03.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m50.88,38.66c-.57,0-1.03-.43-1.03-.96v-11.3c0-.53.46-.96,1.03-.96s1.03.43,1.03.96v11.3c0,.53-.46.96-1.03.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m50.88,18.76c-.57,0-1.03-.43-1.03-.96v-6.97c0-.53.46-.96,1.03-.96s1.03.43,1.03.96v6.97c0,.53-.46.96-1.03.96Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m60.36,5.26v9.89s-3.38-1.53-9.48-4.3V.96c6.1,2.77,9.48,4.3,9.48,4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m60.36,16.1c-.15,0-.31-.03-.45-.1l-9.48-4.3c-.35-.16-.58-.49-.58-.86V.96c0-.33.18-.64.48-.81.3-.17.68-.19,1-.05l9.48,4.3c.35.16.58.49.58.86v9.89c0,.33-.18.64-.48.81-.17.1-.36.15-.55.15Zm-8.45-5.85l7.42,3.37v-7.76l-7.42-3.37v7.76Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m60.36,33.7c-.57,0-1.03-.43-1.03-.96V15.14c0-.53.46-.96,1.03-.96s1.03.43,1.03.96v17.6c0,.53-.46.96-1.03.96Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m60.36,22.1c-6.1,2.77-9.48,4.3-9.48,4.3,0,0-3.38-1.53-9.49-4.3,0,0,3.38-1.53,9.49-4.3,6.1,2.77,9.48,4.3,9.48,4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m50.88,27.35c-.15,0-.31-.03-.45-.1,0,0-3.38-1.53-9.49-4.3-.35-.16-.58-.49-.58-.86s.22-.7.58-.86c0,0,3.38-1.53,9.49-4.3.29-.13.62-.13.9,0,6.1,2.77,9.48,4.3,9.48,4.3.35.16.58.49.58.86s-.22.7-.58.86l-9.48,4.3c-.14.06-.3.1-.45.1Zm-7.14-5.25c3.74,1.69,6.18,2.8,7.14,3.23l7.13-3.23c-1.52-.69-3.94-1.78-7.13-3.23-3.2,1.45-5.61,2.54-7.14,3.23Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m20,34.37c-.57,0-1.03-.43-1.03-.96v-11.3c0-.53.46-.96,1.03-.96s1.03.43,1.03.96v11.3c0,.53-.46.96-1.03.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.51,38.66c-.57,0-1.03-.43-1.03-.96v-11.3c0-.53.46-.96,1.03-.96s1.03.43,1.03.96v11.3c0,.53-.46.96-1.03.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.51,18.76c-.57,0-1.03-.43-1.03-.96v-6.97c0-.53.46-.96,1.03-.96s1.03.43,1.03.96v6.97c0,.53-.46.96-1.03.96Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1.03,5.26v9.89s3.38-1.53,9.48-4.3V.96C4.41,3.72,1.03,5.26,1.03,5.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1.03,16.1c-.19,0-.38-.05-.55-.15-.3-.17-.48-.48-.48-.81V5.26c0-.37.22-.7.58-.86L10.06.1c.32-.14.7-.13,1,.05.3.17.48.48.48.81v9.89c0,.37-.22.7-.58.86L1.48,16c-.14.06-.3.1-.45.1Zm1.03-10.24v7.76l7.42-3.37V2.49l-7.42,3.37Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1.03,33.7c-.57,0-1.03-.43-1.03-.96V15.14c0-.53.46-.96,1.03-.96s1.03.43,1.03.96v17.6c0,.53-.46.96-1.03.96Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1.03,22.1c6.1,2.77,9.48,4.3,9.48,4.3,0,0,3.38-1.53,9.49-4.3,0,0-3.38-1.53-9.49-4.3-6.1,2.77-9.48,4.3-9.48,4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.51,27.35c-.15,0-.31-.03-.45-.1L.58,22.96c-.35-.16-.58-.49-.58-.86s.22-.7.58-.86c0,0,3.38-1.53,9.48-4.3.29-.13.62-.13.9,0,6.1,2.77,9.49,4.3,9.49,4.3.35.16.58.49.58.86s-.22.7-.58.86c-6.11,2.77-9.49,4.3-9.49,4.3-.14.06-.3.1-.45.1Zm-7.13-5.25l7.13,3.23c.95-.43,3.4-1.54,7.14-3.23-1.52-.69-3.94-1.78-7.14-3.23-3.2,1.45-5.61,2.54-7.13,3.23Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMesasSilla);
export default __webpack_public_path__ + "static/media/MESAS-SILLA.0761df7e44c8b74ec9fff96dc5f3d27f.svg";
export { ForwardRef as ReactComponent };